import { createReducer } from '../../util';
import * as actions from '../actions/notifications';

const initialState = {
    unreadCount: 0,
};

export default createReducer(initialState, {
    [actions.NOTIFICATIONS_SET_UNREAD_COUNT]: (state, count) => ({
        ...state,
        unreadCount: count,
    }),
});
